import { reactForceAllUpdate } from '../../component-react'
import { PromptConfirm } from '../confirm'
import { ReducerState } from './types'

export const archiveNotes = <T extends Record<string, unknown>>(
	rs: ReducerState<T>,
	noteIDs: string[],
) => {
	const lbl = noteIDs.length == 1 ? 'this note' : `${noteIDs.length} notes`
	PromptConfirm({
		size: [300, 190],
		msg: `Are you sure you want to archive ${lbl}?`,
		yes: callback => {
			// Send request to server to archive this note
			rs.props.archiving?.onArchive(noteIDs, response => {
				if (response === true) {
					reactForceAllUpdate()
					callback(true)
				} else {
					callback(response)
				}
			})
		},
	})
}

export const deleteNotes = <T extends Record<string, unknown>>(
	rs: ReducerState<T>,
	noteIDs: string[],
) => {
	const lbl = noteIDs.length == 1 ? 'this note' : `${noteIDs.length} notes`
	PromptConfirm({
		size: [300, 190],
		msg: rs.props.deleting?.retainCopy
			? `Are you sure you want to mark ${lbl} as deleted?`
			: `Are you sure you want to permanently delete ${lbl}?`,
		yes: callback => {
			// Send request to server to remove this leave
			rs.props.deleting?.onDelete(noteIDs, response => {
				if (response === true) {
					reactForceAllUpdate()
					callback(true)
				} else {
					callback(response)
				}
			})
		},
	})
}
